var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRightButton(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47,
    height: 48,
    viewBox: "0 0 47 48",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.1667,
    cy: 23.875,
    r: 18.0833,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.499999 23.875C0.5 36.6965 10.9285 47.125 23.75 47.125C36.5714 47.125 47 36.6965 47 23.875C47 11.0536 36.5714 0.625014 23.75 0.625014C10.9285 0.625015 0.499998 11.0536 0.499999 23.875ZM21.4321 13.0516L31.5408 23.1603C31.7382 23.3577 31.8369 23.6144 31.8369 23.875C31.8369 24.1356 31.7382 24.3923 31.5408 24.5897L21.4321 34.6984C21.0372 35.0933 20.3975 35.0933 20.0027 34.6984C19.6078 34.3035 19.6078 33.6639 20.0027 33.269L29.3966 23.875L20.0027 14.481C19.6078 14.0862 19.6078 13.4465 20.0027 13.0516C20.3975 12.6567 21.0372 12.6567 21.4321 13.0516Z",
    fill: "#F86A27"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightButton);
export default __webpack_public_path__ + "static/media/right-button.306be02ccd6d1179b8e33aca87482f6a.svg";
export { ForwardRef as ReactComponent };